export default __webpack_public_path__ + "static/gaku-screen-shadow-3d9466c662d36291371518da2e1ff0dd.png";